let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("60iMu")).then(() => parcelRequire('367TJ'));